import { Print } from 'src/components/print';

export default Print;
